import { getBreakpointWidth } from "Utils/getBreakpointWidth";

export function initFooter() {
   document.querySelectorAll("button.showEnterpriseFormFromFooter")
      .forEach((x: HTMLButtonElement) => x.addEventListener("click", function showEnterpriseFormFromFooter() {
         const options = {
            formType: "Specific",
            mode: "HP",
            formName: "Book a Demo for Your Business",
         };
         LSHelper.Components?.EnterpriseForm(options);
      }));

   document.querySelectorAll("button.showContactUsFormFromFooter")
      .forEach((x: HTMLButtonElement) => x.addEventListener("click", function showContactUsFormFromFooter() {
         const options = {
            formType: "General",
            mode: "HP",
            formName: "Contact Us",
         };
         LSHelper.Components?.EnterpriseForm(options);
      }));

   const downSmWidth = getBreakpointWidth("down", "sm");
   document.querySelectorAll("div.ftr-category-header")
      .forEach((x: HTMLDivElement) => x.addEventListener("click", ev => {
         const mediaQuery = window.matchMedia(`(max-width: ${downSmWidth}px)`);

         if (mediaQuery.matches) {
            (ev.target as HTMLElement).classList.toggle("ftr-category-header--checked");
         }
      }));
}